<template>
  <div class="enterprise-network_container">
    <div class="enterprise-network_container_title">
      Other Contacts
    </div>
    <div class="enterprise-network_container_table">
      <el-table :data="formData" border>
        <el-table-column label="Name" show-overflow-tooltip prop="generalManagerName" />
        <el-table-column
          label="Job Title"
          prop="position"
          show-overflow-tooltip
        />
        <el-table-column
          label="Work Email"
          prop="email"
          show-overflow-tooltip
        />
        <el-table-column
          label="Office Phone"
          prop="officePhone"
          show-overflow-tooltip
        />
      </el-table>
    </div>
  </div>
</template>

<script>

export default {
  name: "enterpriseNetworkOtherContactsDetail",
  props: {
    formData: {
      type: Array,
      default: () => []
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/enterpriseNetwork/components/otherContacts/otherContactsDetail.vue